import type {
  FetchUsersPageOptions,
  UsersListFilter,
  UsersPage,
  UsersRepository,
  UserRolePatch,
} from '../../domain/users/repository';
import {
  countUsers as fetchCount,
  fetchUsersPage as fetchPage,
  syncUserUnsubscribeToken,
  updateUserRoles,
} from '../../services/users';
import type {
  FetchUsersPageOptions as ServiceFetchUsersPageOptions,
  UsersListFilter as ServiceUsersListFilter,
} from '../../services/users';
import type { QueryDocumentSnapshot } from 'firebase/firestore';

function serviceOptions(options: FetchUsersPageOptions): ServiceFetchUsersPageOptions {
  return {
    ...options,
    filter: options.filter as ServiceUsersListFilter,
    cursor: options.cursor as QueryDocumentSnapshot | null | undefined,
  };
}

export function createUsersRepository(): UsersRepository {
  return {
    async fetchPage(options): Promise<UsersPage> {
      const page = await fetchPage(serviceOptions(options));
      return {
        users: page.users,
        lastCursor: page.lastDoc,
        hasMore: page.hasMore,
      };
    },
    countUsers(filter: UsersListFilter, searchQuery?: string) {
      return fetchCount(filter as ServiceUsersListFilter, searchQuery);
    },
    updateUserRoles(uid: string, patch: UserRolePatch) {
      return updateUserRoles(uid, patch);
    },
    syncUserUnsubscribeToken,
  };
}
